import { get, patch, post } from './client.js';

const qs = (p) => p ? '?' + new URLSearchParams(Object.entries(p).filter(([, v]) => v != null)).toString() : '';

export const list       = (params)      => get(`/platform/subscriptions${qs(params)}`);
export const getOne     = (subId)       => get(`/platform/subscriptions/${subId}`);
export const update     = (subId, body) => patch(`/platform/subscriptions/${subId}`, body);
export const activate   = (subId)       => post(`/platform/subscriptions/${subId}/activate`);
export const expire     = (subId)       => post(`/platform/subscriptions/${subId}/expire`);
export const suspend    = (subId)       => post(`/platform/subscriptions/${subId}/suspend`);
export const reactivate = (subId)       => post(`/platform/subscriptions/${subId}/reactivate`);
export const cancel     = (subId)       => post(`/platform/subscriptions/${subId}/cancel`);
export const renew      = (subId)       => post(`/platform/subscriptions/${subId}/renew`);

/* Provision subscriptions (and trial licenses) for all orgs that don't have one yet */
export const migrateMissing = ()        => post(`/platform/orgs/migrate-missing`, {});
